import React from "react";
import toast from "react-hot-toast";

const TYPE_CONFIG = {
  success: { color: "#16a34a", bg: "#ecfdf5", icon: "✓" },
  error: { color: "#dc2626", bg: "#fef2f2", icon: "!" },
  info: { color: "#2563eb", bg: "#eff6ff", icon: "i" },
  warning: { color: "#d97706", bg: "#fffbeb", icon: "!" },
};

const ClassicToast = ({ t, type = "info", message, duration = 3000 }) => {
  const cfg = TYPE_CONFIG[type] || TYPE_CONFIG.info;

  return (
    <div
      style={{
        minWidth: 240,
        maxWidth: 340,
        background: "#ffffff",
        borderRadius: 10,
        boxShadow:
          "0 10px 28px rgba(15, 23, 42, 0.14), 0 2px 6px rgba(15, 23, 42, 0.06)",
        borderLeft: `4px solid ${cfg.color}`,
        overflow: "hidden",
        fontFamily:
          'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
        opacity: t.visible ? 1 : 0,
        transform: t.visible ? "translateX(0)" : "translateX(20px)",
        transition: "opacity 0.2s ease, transform 0.2s ease",
        pointerEvents: "auto",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: 12,
          padding: "12px 14px",
        }}
      >
        <div
          aria-hidden
          style={{
            width: 24,
            height: 24,
            borderRadius: "50%",
            background: cfg.color,
            color: "#ffffff",
            display: "grid",
            placeItems: "center",
            fontSize: 14,
            fontWeight: 800,
            flexShrink: 0,
            marginTop: 1,
            lineHeight: 1,
          }}
        >
          {cfg.icon}
        </div>
        <div
          style={{
            flex: 1,
            fontSize: 14,
            fontWeight: 500,
            color: "#1f2937",
            lineHeight: 1.45,
            paddingTop: 3,
            wordBreak: "break-word",
          }}
        >
          {message}
        </div>
        <button
          type="button"
          onClick={() => toast.dismiss(t.id)}
          aria-label="Close notification"
          style={{
            background: "transparent",
            border: "none",
            cursor: "pointer",
            padding: 0,
            width: 22,
            height: 22,
            color: "#9ca3af",
            fontSize: 20,
            lineHeight: 1,
            display: "grid",
            placeItems: "center",
            flexShrink: 0,
            borderRadius: 4,
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = "#374151")}
          onMouseLeave={(e) => (e.currentTarget.style.color = "#9ca3af")}
        >
          ×
        </button>
      </div>
      <div
        style={{
          height: 3,
          background: cfg.bg,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            height: "100%",
            width: "100%",
            background: cfg.color,
            transformOrigin: "left center",
            animation: `classicToastShrink ${duration}ms linear forwards`,
          }}
        />
      </div>
      <style>{`
        @keyframes classicToastShrink {
          from { transform: scaleX(1); }
          to   { transform: scaleX(0); }
        }
      `}</style>
    </div>
  );
};

export const showToast = (type, message, duration = 3000) =>
  toast.custom(
    (t) => (
      <ClassicToast t={t} type={type} message={message} duration={duration} />
    ),
    { duration },
  );

export default ClassicToast;
